export const environment = {
  production: false,
  // eslint-disable-next-line no-undef
  BACKEND: process.env.REACT_APP_URL || "https://api.leadzlab.co",
};
